var debounce = require('lodash.debounce');

import MiniMasonry from "minimasonry";

import shopifyProductCard from '../../components/shopify/shopifyProductCard';
import shopifyCollectionCard from '../../components/shopify/shopifyCollectionCard';
import shopifyCollectionProducts from '../../components/shopify/shopifyCollectionProducts';

var vue = new Vue({
    el: '#main-wrapper',
    components: {
        shopifyProductCard,
        shopifyCollectionCard,
        shopifyCollectionProducts
    },
    data: {
        store: null,
        product_lists: [],
        store_page_username: null,
        selected_tab: '#store-tab',
        store_products: {
            search: '',
            data: [],
            loading: false,
            load_more: true,
            pagination: {
                per_page: 40,
                page: 1
            },
            masonry: null,
            masonry_container: '.product-masonry-grid',
            masonry_needs_init: false,
            search_category: null,
            category: null,
            subcategory: null,
        },
        product_keyword_suggestions: {
            data: [],
            loading: false,
            limit: 14,
            total_size: 0,
            clear_selected: false
        },
        selected_keywords: [],
        show_more_category_filters: false,
        has_show_more_category_filters_button: false,
        display_store_products: false,
        store_collections: {
            search: '',
            data: [],
            loading: false,
            load_more: true,
            pagination: {
                per_page: 24,
                page: 1
            },
        },
        selected_shopify_collection: null,
        collection_handle: null,
        reviews: {
            pagination: {
                per_page: 5,
                page: 1
            },
            load_more: true,
            loading: false,
            data: [],
        },
    },
    computed: {
        
    },
    created: function () {
        var self = this;
        this.store_page_username = $('[name=store_page_username]').val();
        this.store_products.data = window.store_products;
        
        if(window.store_collections && window.store_collections.length){
            this.store_collections.data = window.store_collections;
        }
        
        if($('[name=collection_handle').length){
            this.selected_tab = '#collections-tab';
        }
        window.addEventListener('resize', this.onResize);

    },
    mounted: function () {
        var self = this;

        this.store = JSON.parse($('[name=store]').val());
        this.product_lists = window.product_lists;
        self.initMasonryGrid(self.store_products);
        
        
//        this.initIntersection(document.getElementById('StoreProductListContainer'), this.searchProducts);
//        this.initIntersection(document.getElementById('ShopifyCollectionList'), this.getStoreCollections);
        this.getProductKeywordSuggestions();
        
        $('#store-tab').on('shown.bs.tab', function (event) {
            if(self.store_products.masonry_needs_init){
                self.initMasonryGrid(self.store_products);
                self.calculateTagLimit();
            }
        });
        
        this.has_show_more_category_filters_button = $('#CategoryFilterTable').height() >= 454;
        
        if($('[name=collection_handle').length){
            this.collection_handle = $('[name=collection_handle').val();
            for(var i=0; i < this.store_collections.data.length; i++){
                var collection = this.store_collections.data[i];
                if(collection.handle === this.collection_handle){
                    this.selectShopifyCollection(collection, true);
                    break;
                }
            }
            this.showTab('#collections-tab');
        } else if(window.location.href.includes('/collection')){
            this.showTab('#collections-tab');
        }
        
        this.initIntersection(document.getElementById('aboutStoreModal'), this.getReviews);
    },
    methods: {
        openAboutModal: function(){
            $('#aboutStoreModal').modal('show');
        },
        showTab: function(tab){
            if($(tab).hasClass('active')){
                return; //Tab is already active
            }
            $('[data-toggle=tab]').removeClass('active'); //Remove highlight from all other tabs
            $(tab).tab('show');
            this.selected_tab = tab;
        },
        filterByCategory: function(event){
            var el = event.currentTarget;
            if(!el){
                return;
            }
            $("[data-category]").removeClass('font-weight-bold');
            $(el).addClass('font-weight-bold');
            var category_name = el.dataset.category;      
            console.log(el.dataset);
            if(!category_name || this.store_products.loading){
                return;
            }
            this.store_products.category = el.dataset.category;
            this.store_products.subcategory = el.dataset.subcategory;
            this.store_products.pagination.page = 1;
            this.clearKeywordSuggestions();
            this.searchProducts();
            
        },
        clearCategoryFilter: function(){
            if(this.store_products.loading){
                return;
            }
            $("[data-category]").removeClass('font-weight-bold');
            this.store_products.search_category = null;
            this.store_products.pagination.page = 1;
            this.searchProducts();
        },
        clearKeywordSuggestions: function(){
            this.selected_keywords = [];
            this.store_products.search = '';
            this.product_keyword_suggestions.clear_selected = true;
        },
        searchProducts: function() {
            this.getStoreProducts();
            this.getProductKeywordSuggestions();
        },
        getStoreProducts: function () {
            var self = this;
            if (this.store_products.loading) {
                return;
            }
            self.store_products.loading = true;
            var url = '/api/v5/shopify/store/' + this.store.id + '/products';
            var params = {
                format_for_card: null,
                search: this.store_products.search,
                page: this.store_products.pagination.page,
                per_page: this.store_products.pagination.per_page,
                search_categories: this.store_products.search_category,
                main_category: this.store_products.category,
                subcategory: this.store_products.subcategory,
                match_all_keywords: true,
                disable_no_results_fallback: true,
            };

            axios.get(url, {params: params}).then(function (response) {
                
                if(!self.display_store_products){
                    //Prepare loading products with javascript
                    self.store_products.masonry = null;
                    self.display_store_products = true;
                }
                $('#LoadedStoreProductsList').remove();
                
                var data = response.data.data;
                if (params.page === 1) {
                    self.store_products.load_more = true;
                    self.store_products.data = data;
                } else {
                    for (var i = 0; i < data.length; i++) {
                        var product = data[i];
                        self.addStoreProduct(product);
                    }
                }

                if (!data.length || data.length < params.per_page) {
                    self.store_products.load_more = false;
                }
                if (response.data.pagination && params.page === response.data.pagination.last_page) {
                    self.store_products.load_more = false;
                }
                
                if (self.selected_tab === '#store-tab') {
                    Vue.nextTick(function () {
                        self.initMasonryGrid(self.store_products);
                    });
                } else {
                    self.store_products.masonry_needs_init = true;
                }

                self.store_products.loading = false;
            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.store_products.loading = false;
            });
        },
        addStoreProduct: function (new_product) {
            var found = false;
            for (var i = 0; i < this.store_products.data.length; i++) {
                var product = this.store_products.data[i];
                if (product.id === new_product.id) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.store_products.data.push(new_product);
            }
        },
        loadMoreStoreProducts: function () {
            if (this.store_products.loading || !this.store_products.load_more) {
                return;
            }
            this.store_products.pagination.page++;
            this.searchProducts();
        },
        calculateKeywordSizes: function (data) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            ctx.font = '12px Poppins';
            var word_sizes = [];
            var total_size = 0;

            for (var i = 0; i < data.length; i++) {
                var keyword = data[i];
                if (typeof keyword === 'object') {
                    obj = keyword;
                } else {
                    var keyword_width = ctx.measureText(keyword).width;
                    var obj = {
                        keyword: keyword,
                        size: Math.max(keyword_width + 26, 54)
                    };
                }

                total_size += obj.size;
                word_sizes.push(obj);
            }
            this.product_keyword_suggestions.data = word_sizes;
            this.product_keyword_suggestions.total_size = total_size;
        },
        calculateTagLimit: function () {
            var window_width = document.getElementById('SearchHeaderContainer').offsetWidth;
            var reserved_width = 80;
            var available_width = window_width - reserved_width;
            var count = 0;
            for (var i = 0; i < this.product_keyword_suggestions.data.length; i++) {
                var obj = this.product_keyword_suggestions.data[i];
                if (obj.size > available_width) {
                    break;
                }
                available_width -= obj.size;
                count++;
            }

            this.product_keyword_suggestions.limit = count;
        },
        onResize: debounce(function () {
            this.calculateTagLimit();

            //Masonry will automatically update the layout on resize
            //But if the tab is not active it'll mess up the layout
            //Use a flag to update the layout when going back to the tab
            if (this.selected_tab !== '#store-tab') {
                this.store_products.masonry_needs_init = true;
            }

        }, 250),
        getProductKeywordSuggestions: function () {
            var self = this;
            self.product_keyword_suggestions.loading = true;
            var url = '/api/v5/shopify/products/keyword-suggestions';

            var params = {
                shop_id: this.store.id,
                search_categories: this.store_products.search_category,
                search: this.store_products.search,
                match_all_keywords: true,
                disable_no_results_fallback: true,
            };

            axios.get(url, {params: params}).then(function (response) {
                
                if(self.product_keyword_suggestions.clear_selected){
                    self.product_keyword_suggestions.clear_selected = false;
                    self.product_keyword_suggestions.data = [];
                }
                
                var data = response.data.data;

                var suggestions_to_keep = self.product_keyword_suggestions.data.filter(function (suggestion) {
                    return suggestion.active;
                });

                data = suggestions_to_keep.concat(data);

                self.calculateKeywordSizes(data);

                if (self.selected_tab === '#store-tab') {
                    self.calculateTagLimit();
                } else {
                    self.store_products.masonry_needs_init = true;
                }

                self.product_keyword_suggestions.loading = false;
            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.product_keyword_suggestions.loading = false;
                self.showErrorMessage(error);
            });
        },
        addKeyword: function (suggestion) {
            if (this.store_products.loading || this.product_keyword_suggestions.loading) {
                return;
            }
            Vue.set(suggestion, 'active', !suggestion.active);

            var index = this.selected_keywords.indexOf(suggestion.keyword);
            if (index >= 0) {
                this.selected_keywords.splice(index, 1);
            } else {
                this.selected_keywords.push(suggestion.keyword);
            }

            this.store_products.search = this.selected_keywords.join(' ');
            this.store_products.pagination.page = 1;
            this.searchProducts();
        },
        showMoreCategoryFilters: function () {
            this.show_more_category_filters = true;
        },
        resizeMasonryGrid: function(){
            if(this.selected_tab === '#store-tab'){
                this.initMasonryGrid(this.store_products);
            }
        },
        initMasonryGrid: function(obj){
            var self = this;
            if(obj.masonry){
                obj.masonry.layout();
            } else {
                $(obj.masonry_container).addClass('masonry-initialized');
                var masonry = new MiniMasonry({
                    container: obj.masonry_container,
                    baseWidth: 210,
                    minify: false
                });
                obj.masonry = masonry;
            }
        },
        getStoreCollections: function(){
            var self = this;
            if(this.store_collections.loading){
                return;
            }
            self.store_collections.loading = true;
            var url = '/api/v5/shopify/store/' + this.store.id + '/collections';
            var params = {
                search: this.store_collections.search,
                page: this.store_collections.pagination.page,
                per_page: this.store_collections.pagination.per_page,
            };

            if(this.store_collections.page_info){
                params.page_info = this.store_collections.page_info;
            }
            axios.get(url, {params:params}).then(function (response) {
                var data = response.data.data;
                if(params.page === 1){
                    self.store_collections.load_more = true;
                    self.store_collections.data = data;
                } else {
                    self.store_collections.data = self.store_collections.data.concat(data);
                }

                if (!data.length || data.length < params.per_page) {
                    self.store_collections.load_more = false;
                }
                if(response.data.pagination && params.page === response.data.pagination.last_page){
                    self.store_collections.load_more = false;
                }

                self.store_collections.loading = false;

            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.store_collections.loading = false;
            });
        },
        selectShopifyCollection: function(collection, ignore_history){
            this.showTab('#collections-tab');
            this.selected_shopify_collection = collection;
            
            if(collection && collection.profile_url && !ignore_history){
                var old_title = document.title;
                var new_title = collection.title + ' Collection - ' + this.store.name;
                history.pushState({}, "", collection.profile_url);
                document.title = new_title;
            }
        },
        searchShopifyCollections: debounce(function(){
            this.store_collections.pagination.page = 1;
            this.getStoreCollections();
        }, 500),
        loadMoreStoreCollections: function(){
            if(this.store_collections.loading || !this.store_collections.load_more){
                return;
            }
            this.store_collections.pagination.page++;
            this.getStoreCollections();
        },
        getReviews: function(){
            var self = this;
            if(this.reviews.loading){
                return;
            }
            self.reviews.loading = true;
            var url = '/api/v5/shopify/store/' + this.store.id + '/reviews';
            var params = {
                page: this.reviews.pagination.page,
                per_page: this.reviews.pagination.per_page,
            };

            axios.get(url, {params:params}).then(function (response) {
                var data = response.data.data;

                if(params.page === 1){
                    self.reviews.load_more = true;
                    self.reviews.data = data;
                } else {
                    self.reviews.data = self.reviews.data.concat(data);
                }

                if (!data.length || data.length < params.per_page) {
                    self.reviews.load_more = false;
                }
                if(response.data.pagination && params.page === response.data.pagination.last_page){
                    self.reviews.load_more = false;
                }

                self.reviews.loading = false;
            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.reviews.loading = false;
            });
        },
    }
});



// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/views/shop/storeProfileV2.js